// 870b24123758df93ad9abd7ed569089df03fe856|name=EmailDraftResponse|schemaHash=84099e3b5d23998bde6ab1b51e69e97ef58bbf69|kind=parser-js

import { setDefinedValue } from '@myre/common-primitives';

export function parseEmailDraftResponseFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'subject', _data.subject);
  setDefinedValue(result, 'body', _data.body);

  return result;
}

export function parseEmailDraftResponseToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'subject', _data.subject);
  setDefinedValue(result, 'body', _data.body);

  return result;
}
